import { Step } from '~components/wizard-form/props';
import { Process, Resolve, Upload } from '~support-at-home/components/claims/reconciliations-wizard';

const steps: Step[] = [
  {
    step: 1,
    title: 'Upload',
    fields: {
      upload: {
        type: 'custom',
        component: Upload,
        colSize: 12,
      },
    },
  },
  {
    step: 2,
    title: 'Process',
    fields: {
      process: {
        type: 'custom',
        component: Process,
        colSize: 12,
        dependencies: ['upload'],
      },
      reconciliationId: {
        type: 'hidden',
      },
    },
    showNextButton: ({ values }) => !!values.reconciliationId,
  },
  {
    step: 3,
    title: 'Resolve',
    fields: {
      resolve: {
        type: 'custom',
        component: Resolve,
        colSize: 12,
        dependencies: ['reconciliationId'],
      },
    },
    showPrevButton: false,
  },
];

export default steps;
